@if (selectedConfig.tagType === 'status') {
  <oui-tag
    type="status"
    [status]="statusValue"
    [size]="size"
    [declination]="selectedConfig.declination">
    {{ statutText }}
  </oui-tag>
}
@if (selectedConfig.tagType === 'brand') {
  <oui-tag
    type="brand"
    [brand]="brandValue"
    [size]="size"
    [declination]="selectedConfig.declination">
    {{ statutText }}
  </oui-tag>
}
